import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { ctaFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteCourseSearchWidgetV2Fragment = contentfulGql`#graphql
  ${ctaFragment}
  fragment EntWebsiteCourseSearchWidgetV2 on EntWebsiteCourseSearchWidgetV2 {
    headline
    slug
    searchResultMessage
    searchResultCta {
      ...Cta
    }
    coursesCount
    certificatesCount
    handsOnLabsCount
    clipsCount
  }
`;

export const entWebsiteBlockCourseSearchWidgetV2Query = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteCourseSearchWidgetV2Fragment}
  query entWebsiteBlockCourseSearchWidgetV2($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteCourseSearchWidgetV2
      }
    }
  }
`;
